"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const button_1 = __importDefault(require("components/cosmos/button/button"));
const modal_1 = require("components/cosmos/v2/modal");
const Html_1 = __importDefault(require("components/Html"));
const translationContext_1 = require("configs/translationContext");
const services_1 = require("modules/app/services");
const clickFreeModuleGiveUpSchema_1 = require("modules/app/services/datahubEvents/freeModule/clickFreeModuleGiveUpSchema");
const clickFreeModuleGoBackSchema_1 = require("modules/app/services/datahubEvents/freeModule/clickFreeModuleGoBackSchema");
const viewFreeModuleModalSchema_1 = require("modules/app/services/datahubEvents/freeModule/viewFreeModuleModalSchema");
const confirm_exit_svg_1 = __importDefault(require("./assets/confirm-exit.svg"));
const signUpModal_1 = require("./signUpModal");
const ConfirmExit = ({ onPreviousStep, onClose }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    (0, react_1.useEffect)(() => {
        const schema = new viewFreeModuleModalSchema_1.ViewFreeModuleModalSchema({
            step: signUpModal_1.ViewFreeModuleSteps.GIVE_UP
        });
        services_1.DatahubEventsService.sendEvent({ schema });
    }, []);
    const handleGoBack = () => {
        const schema = new clickFreeModuleGoBackSchema_1.ClickFreeModuleGoBackSchema({
            componentName: 'FreeModuleModalExitGoBackButton'
        });
        services_1.DatahubEventsService.sendEvent({ schema });
        onPreviousStep();
    };
    const handleGiveUp = () => {
        const schema = new clickFreeModuleGiveUpSchema_1.ClickFreeModuleGiveUpSchema();
        services_1.DatahubEventsService.sendEvent({ schema });
        onClose();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(modal_1.Modal.Header, {}), (0, jsx_runtime_1.jsxs)(modal_1.Modal.Body, { className: "_d-flex _align-items-center _flex-column", children: [(0, jsx_runtime_1.jsx)("img", { src: confirm_exit_svg_1.default, className: "", alt: "" }), (0, jsx_runtime_1.jsxs)("div", { className: "_text-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "_text-4 _mt-4 _text-gray-900", children: t('module_editor.active_free_signup.step4.title') }), (0, jsx_runtime_1.jsx)("div", { className: "_text-2 _text-gray-500 _mt-4", children: (0, jsx_runtime_1.jsx)(Html_1.default, { children: t('module_editor.active_free_signup.step4.subtitle') }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _justify-content-end _mt-6 _w-full", children: [(0, jsx_runtime_1.jsx)(button_1.default, { variation: "secondary", className: "_mr-2", onClick: handleGoBack, children: t('module_editor.active_free_signup.step4.back') }), (0, jsx_runtime_1.jsx)(button_1.default, { variation: "danger", onClick: handleGiveUp, children: t('module_editor.active_free_signup.step4.deactivate') })] })] })] }));
};
exports.default = ConfirmExit;
